/**
 * @fileoverview ExtractedNameField component for displaying the original extracted name.
 * Shows a readonly field with the name that was originally extracted from the document.
 */

import { useTranslation } from "@/i18n";

/**
 * Props for the ExtractedNameField component.
 */
interface ExtractedNameFieldProps {
  /** The extracted name value to display */
  readonly value: string;
}

/**
 * ExtractedNameField displays the original name that was extracted from the document.
 * This field is always readonly and shows what was detected before any linking occurred.
 *
 * @param props - Component props
 * @returns Readonly extracted name field UI
 */
export default function ExtractedNameField({ value }: ExtractedNameFieldProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      <label className="text-sm text-[#18181b] leading-5">
        {t("documentReview.modal.extractedNameFromDocument")}
      </label>
      <input
        value={value}
        readOnly
        className="w-full h-10 bg-[#fafafa] rounded-md px-4 py-1 text-sm text-[#71717a] opacity-50 cursor-not-allowed focus:outline-none"
      />
    </div>
  );
}
